import React from 'react';
import { X } from 'lucide-react';
import TradePartnerForm from './TradePartnerForm';

export default function TradePartnerModal({ open, onClose }) {
  if (!open) return null;
  return (
    <div className="tp-overlay" onClick={onClose} data-testid="trade-partner-modal">
      <div className="tp-modal" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
        <button className="tp-close" onClick={onClose} aria-label="Close" data-testid="trade-partner-close"><X size={20} /></button>
        <TradePartnerForm />
      </div>
    </div>
  );
}
